import * as Scrivito from "scrivito";
import { useNavigation } from "^/Context/NavigationContext";
import getHomepage from "../../utils/getHomepage";
import MainNavigationItem from "./MainNavigationItem";

function MainNavigation({ currentPage }) {
  const homepage = getHomepage(currentPage);
  const { activeMainItem } = useNavigation();

  return (
    <nav
      id="main-navigation"
      className="d-none d-md-flex justify-content-end"
      role="navigation"
      aria-label="Main Navigation"
    >
      <Scrivito.ChildListTag
        parent={homepage}
        renderChild={(child) => (
          <MainNavigationItem
            child={child}
            className={
              activeMainItem?.id() === child.id()
                ? "active with-arrow"
                : "inactive"
            }
          />
        )}
      />
    </nav>
  );
}

export default Scrivito.connect(MainNavigation);
